export const LISTING_TYPE = {
  DAILY_BOOKING: 'daily-booking',
  HOURLY_BOOKING: 'hourly-booking',
  PRICE_NEGOTIATION: 'price-negotiatin',
  PRODUCT: "product"
};

export const subscriptionFAQ = [
  {
    label: 'Is there a free trial?',
    body:
      'No, ow-ups.',
  },
  {
    label: 'Can I change my plan later?',
    body:
      'Your subscription will include the Warm-Up Plan for one year. You can unlock the Pro Plan and receive a discount i.',
  },
  {
    label: 'What is the cancellation policy?',
    body:
      'You can cancel your subscription at any time before it renews (1 year from the payment date). If you cancel during your active subscription, you will retain access to the platform until the end of the paid period.',
  },
];


export const TRANSITIONS = {
  ISSUE_DEPOSIT_PAYMENT_LINK: 'transition/issue-deposit-payment-link',
  ISSUE_REST_PAYMENT_LINK: 'transition/issue-rest-payment-link',
  ISSUE_FULL_PAYMENT_LINK: 'transition/issue-full-payment-link',

  INITIATE_DEPOSIT_PAYMENT: 'transition/initiate-deposit-payment',

  DEPOSIT_PAYMENT_LINK_EXPIRE: 'transition/deposit-payment-link-expire',

  INITIATE_REST_PAYMENT: 'transition/initiate-rest-payment',

  INITIATE_FULL_PAYMENT: 'transition/initiate-full-payment',
}